<template>
  <section class="client">
    <div>
      <!-- <loader :isLoading="isLoading"></loader> -->
      <div class="container-fluid">
        <form v-on:submit.prevent="onSubmit()">
          <div class="col-md-12 mb-1">
            <br />
            <div class="row">
              <div class="col-md-12 row">
                <div
                  class="col-md-3"
                  v-if="singleChannel.saleschannel != ''"
                  :disabled="true"
                >
                  <b-input-group>
                    <select
                      v-model="searchchannel1"
                      name="searchchannel1"
                      class="form-control"
                      disabled="true"
                    >
                      <option selected disabled value="">
                        {{ $t("orders.salesChannelPlaceHolder") }}
                      </option>
                      <option
                        v-for="channel in allchannels"
                        v-bind:value="channel.saleschannel"
                      >
                        {{ channel.saleschannel }}
                      </option>
                    </select>
                  </b-input-group>
                </div>
                <div v-else class="col-md-3">
                  <b-input-group>
                    <select
                      v-model="searchchannel1"
                      name="searchchannel1"
                      class="form-control"
                    >
                      <option selected disabled value="">
                        {{ $t("orders.salesChannelPlaceHolder") }}
                      </option>
                      <option
                        v-for="channel in nonselectedChannelList"
                        v-bind:value="channel.saleschannel"
                      >
                        {{ channel.saleschannel }}
                      </option>
                    </select>
                  </b-input-group>
                  <span v-if="searchchannel1 == ''" class="text-danger">
                    {{$t('sla.saleschannelrequired')}}</span
                  >
                </div>
                <div class="col-md-2">{{$t('sla.tattype')}} :</div>
                <div style="margin: 4px 10px">
                  <b-form-fieldset>
                    <input
                      type="radio"
                      :name="singleChannel.name"
                      v-model="tatType"
                      value="1"
                      style="z-index: 1 !important"
                      :checked="tatType =='1'"
                    />
                  </b-form-fieldset>
                </div>
                <div class="col-md-2">
                  <label class="radio-inline"> {{$t('sla.fixeduration')}}</label>
                </div>
                <div style="margin: 4px 10px">
                  <b-form-fieldset>
                    <input
                      type="radio"
                      :name="singleChannel.name"
                      v-model="tatType"
                      value="2"
                      style="z-index: 1 !important"
                      :checked="tatType =='2'"
                      @change="transitFixedDurAndCutoffBased"
                    />
                  </b-form-fieldset>
                </div>
                <div class="col-md-2">
                  <label class="radio-inline"> {{$t('sla.cutoffbased')}} </label>
                </div>
              </div>
            </div>

            <div class="row" v-if="tatType == '1'" style="margin: 5px">
              <div class="col-md-3">{{$t('sla.duration')}}</div>
              <div class="col-md-2">
                <b-input-group>
                  <b-form-input
                  required
                    type="number"
                    :placeholder="$t('sla.hrs')"
                    name="hr"
                    id="hr"
                    v-model="outbound.fixedhrs"
                    @keyup=""
                    min="0"
                    max="167"
                    v-validate="'required|min_value:1|max_value:167'"
                  ></b-form-input>
                </b-input-group>
              </div>
              <div class="col-md-2">
                <b-input-group>
                  <b-form-input
                  required
                    type="number"
                    :placeholder="$t('sla.mins')"
                    name="min"
                    id="min"
                    v-model="outbound.fixedmin"
                    @keyup=""
                    min="0"
                    max="59"
                    v-validate="'required|min_value:1|max_value:59'"
                  ></b-form-input>
                </b-input-group>
              </div>
              <div v-if="fixedErr" class="col-md-3">
                <span class="text-danger">{{ fixedErr }}</span>
              </div>
            </div>

            <div class="row" v-else>
              <div class="col-md-12 row" style="margin: 5px">
                <div class="col-md-3">{{$t('sla.ordercreationcutoff')}}</div>
                <div class="col-md-2">
                  <b-input-group>
                    <b-form-input
                    required
                      type="number"
                      :placeholder="$t('sla.day')"
                      name="day"
                      id="day"
                      min="1"
                      max="7"
                      v-model="outbound.cuttofday"
                      @keyup=""
                      v-validate="'required|min_value:1|max_value:7'"
                      disabled
                    ></b-form-input>
                  </b-input-group>
                </div>
                <div class="col-md-2">
                  <b-input-group>
                    <b-form-input
                    required
                      type="number"
                      :placeholder="$t('sla.hrs')"
                      name="hr"
                      id="hr"
                      v-model="outbound.cuttofhrs"
                      @keyup=""
                      min="0"
                      max="24"
                      v-validate="'required|min_value:1|max_value:24'"
                    ></b-form-input>
                  </b-input-group>
                </div>
                <div class="col-md-2">
                  <b-input-group>
                    <b-form-input
                    required
                      type="number"
                      :placeholder="$t('sla.mins')"
                      name="min"
                      id="min"
                      v-model="outbound.cuttofmin"
                      @keyup=""
                      min="0"
                      max="59"
                      v-validate="'required|min_value:1|max_value:59'"
                    ></b-form-input>
                  </b-input-group>
                </div>
                <div v-if="cuttofErr" class="col-md-3">
                  <span class="text-danger">{{ cuttofErr }}</span>
                </div>
              </div>
              <div class="col-md-12 row" style="margin: 5px">
                <div class="col-md-3">{{$t('sla.outboundsla')}}</div>
                <div class="col-md-2">
                  <b-input-group>
                    <b-form-input
                    required
                      type="number"
                      :placeholder="$t('sla.day')"
                      name="day"
                      id="day"
                      v-model="outbound.orderday"
                      @keyup=""
                      min="1"
                      max="7"
                      v-validate="'required|min_value:1|max_value:7'"
                    ></b-form-input>
                  </b-input-group>
                </div>
                <div class="col-md-2">
                  <b-input-group>
                    <b-form-input
                    required
                      type="number"
                      :placeholder="$t('sla.hrs')"
                      name="hr"
                      id="hr"
                      v-model="outbound.orderhrs"
                      @keyup=""
                      min="0"
                      max="24"
                      v-validate="'required|min_value:1|max_value:24'"
                    ></b-form-input>
                  </b-input-group>
                </div>
                <div class="col-md-2">
                  <b-input-group>
                    <b-form-input
                    required
                      type="number"
                      :placeholder="$t('sla.mins')"
                      name="min"
                      id="min"
                      v-model="outbound.ordermin"
                      @keyup=""
                      min="0"
                      max="59"
                      v-validate="'required|min_value:1|max_value:59'"
                    ></b-form-input>
                  </b-input-group>
                </div>
                <div v-if="outboundErr" class="col-md-3">
                  <span class="text-danger">{{ outboundErr }}</span>
                </div>
              </div>
            </div>

            <div v-if="singleChannel.saleschannel == ''" class="col-md-12">
              <div class="float-right">
                <button type="submit" class="btn btn-success">
                  {{ $t("common.saveBtn") }}
                </button>
                <button type="reset" @click="reset()" class="btn btn-danger">
                   {{ $t("common.resetBtn") }}
                </button>
              </div>
            </div>

            <div v-else class="col-md-12">
              <div class="float-right">
                <button type="submit" class="btn btn-success">
                  {{ $t("common.updateBtn") }}
                </button>
                <button
                  type="reset"
                  @click="deleteChannel()"
                  class="btn btn-danger"
                >
                  {{ $t("common.delete") }}
                </button>
              </div>
            </div>
            <br /><br />
          </div>
        </form>
      </div>
    </div>
  </section>
</template>
<script>
import common_helper from '../../../../common_helper';
import CryptoJS from 'crypto-js';
import axios from 'axios';
import apiUrl from '../../../../constants';
export default {
  name: "SalesChannelTat",
  components: {},
  props: ["singleChannel", "nonselectedChannelList", "allchannels", "outboundSalesChannelData"],
  data() {
    return {
      outbound: {
        fixedhrs: "",
        fixedmin: "",
        cuttofhrs: "",
        cuttofmin: "",
        cuttofday: 1,
        orderhrs: "",
        ordermin: "",
        orderday: "",
      },
      outboundConfigId:"",
      fixedErr: "",
      cuttofErr: "",
      outboundErr: "",
      tatType: "1",
      globalThresholds: {
        saleschannelOutbound: {
          fixedDuration:{
            hrs: '',
            min: ''
          },
          cutoffbased: {
            hrs: '',
            min: ''
          }
        }
      },
      searchchannel1: this.singleChannel.saleschannel
        ? this.singleChannel.saleschannel
        : "",
    };
  },

  beforeMount(){
        const outboundConfig = this.singleChannel;
				this.outboundConfigId = outboundConfig.id;
				if(outboundConfig.tattype === 'cutoff'){
					this.outbound.cuttofday = outboundConfig.tattime && outboundConfig.tattime.days ? outboundConfig.tattime.days : 0;
					this.outbound.cuttofhrs =  outboundConfig.tattime && outboundConfig.tattime.hours ? outboundConfig.tattime.hours : 0;
					this.outbound.cuttofmin = outboundConfig.tattime && outboundConfig.tattime.minutes || 0;
					this.outbound.orderday = outboundConfig.outboundsla && outboundConfig.outboundsla.days ? outboundConfig.outboundsla.days : 0;
					this.outbound.orderhrs = outboundConfig.outboundsla && outboundConfig.outboundsla.hours ? outboundConfig.outboundsla.hours: 0;
					this.outbound.ordermin = outboundConfig.outboundsla && outboundConfig.outboundsla.minutes || 0;
					this.tatType= "2";
				}else{
					this.outbound.fixedhrs = outboundConfig.tattime && outboundConfig.tattime.hours || 0;
					this.outbound.fixedmin =  outboundConfig.tattime && outboundConfig.tattime.minutes || 0;
					this.tatType= "1";
				}
  },
  mounted() {
    this.getThresholdsGlobal();
  },
  computed: {},
  filters: {},

  methods: {
    async getThresholdsGlobal(){
			const userToken = window.localStorage.getItem('userToken');
			const myStr = userToken.replace(/"/g, '');
      const inputOutbound = ({
				slalevel: 'global',
				module: 'outbound',
			});
			const resultOutbound = await axios({
				method: 'GET',
				'url': apiUrl.api_url + 'sla-configs',
				'params': inputOutbound,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
			if(resultOutbound.status == 200 && resultOutbound.data.data.length > 0){
				const outboundConfig = resultOutbound.data.data[0];
				if(outboundConfig.tattype === 'cutoff'){
                this.globalThresholds.saleschannelOutbound.cutoffbased.hrs = outboundConfig.nearbreach && outboundConfig.nearbreach.hours || 0;
				        this.globalThresholds.saleschannelOutbound.cutoffbased.min = outboundConfig.nearbreach && outboundConfig.nearbreach.minutes || 0;
                console.log("\n\n@@@CutOFF SalesChannel", this.globalThresholds.saleschannelOutbound.cutoffbased.hrs, this.globalThresholds.saleschannelOutbound.cutoffbased.min)
                this.globalThresholds.saleschannelOutbound.fixedDuration.hrs =this.globalThresholds.saleschannelOutbound.cutoffbased.hrs;
                this.globalThresholds.saleschannelOutbound.fixedDuration.min = this.globalThresholds.saleschannelOutbound.cutoffbased.min;
				}else{
                this.globalThresholds.saleschannelOutbound.fixedDuration.hrs = outboundConfig.nearbreach && outboundConfig.nearbreach.hours || 0;
				        this.globalThresholds.saleschannelOutbound.fixedDuration.min = outboundConfig.nearbreach && outboundConfig.nearbreach.minutes || 0;
                this.globalThresholds.saleschannelOutbound.cutoffbased.hrs = this.globalThresholds.saleschannelOutbound.fixedDuration.hrs;
                this.globalThresholds.saleschannelOutbound.cutoffbased.min = this.globalThresholds.saleschannelOutbound.fixedDuration.min;
                console.log("\n\nFIXED DURATION", this.globalThresholds.saleschannelOutbound.fixedDuration.hrs, this.globalThresholds.saleschannelOutbound.fixedDuration.min)
				}
			}
    },
    async transitFixedDurAndCutoffBased(){
            // this.selectedChannelList = []
            // this.nonselectedChannelList = []
            // this.channellist = []
            this.outboundSalesChannelData = []
            await this.getOutboundConfig();
            this.tatType = "2";
        },
    deleteChannel() {
      if(this.outboundConfigId > 0){
        this.$parent.deleteChannel(this.searchchannel1, this.outboundConfigId);
      }
    },
    onSubmit() {
      this.addChannel();
    },

    async addChannel() {
      await this.getThresholdsGlobal();
      let payload = {};
      if(this.tatType == "1"){
        if(this.outbound.fixedhrs==0 && this.outbound.fixedmin==0){
            this.fixedErr="Both Hr and min cannot be zero";
            return false;
        }
        else{
            this.fixedErr='';
            if (parseInt(this.globalThresholds.saleschannelOutbound.fixedDuration.hrs * 60) + parseInt(this.globalThresholds.saleschannelOutbound.fixedDuration.min) >= parseInt(this.outbound.fixedhrs*60) + parseInt(this.outbound.fixedmin)) {
            this.$alertify.alert(this.$t('sla.durationError'), this.$t('sla.durationErrMsg') + "<br/>" + `<b> ${this.$t('sla.thresholdDuration')}: ${this.globalThresholds.saleschannelOutbound.fixedDuration.hrs} ${this.$t('sla.hours')} ${this.globalThresholds.saleschannelOutbound.fixedDuration.min} ${this.$t('sla.minutes')} </b>`);
            return false;
          }
            payload = {
              tattype: "fixed",
              saleschannel: this.searchchannel1,
              tattime: `${this.outbound.fixedhrs}:${this.outbound.fixedmin}`
            }
            this.$parent.saveNewChannel(payload, this.outboundConfigId);
            this.outbound.cuttofday = 1;
            this.outbound.cuttofhrs =  '';
            this.outbound.cuttofmin = '';
            this.outbound.orderday = '';
            this.outbound.orderhrs = '';
            this.outbound.ordermin = '';
        }
      } else {
        if((this.outbound.cuttofday==0 && this.outbound.cuttofhrs==0 && this.outbound.cuttofmin==0)){
            this.cuttofErr='All three fields cannot be zero';
            return false;
        }else if((this.outbound.orderday==0 && this.outbound.orderhrs==0 && this.outbound.ordermin==0)){
            this.outboundErr='All three fields cannot be zero';
            return false;
        }else {
          let totalOrderMins = parseInt(this.outbound.orderday*24*60) + parseInt(this.outbound.orderhrs*60) + parseInt(this.outbound.ordermin);
          let totalCutoffMins = parseInt(this.outbound.cuttofday*24*60) + parseInt(this.outbound.cuttofhrs*60) + parseInt(this.outbound.cuttofmin)
            if(totalCutoffMins >= totalOrderMins){
            this.outboundErr = this.$t('sla.OutboundSlaAndOrderCreationCutoff');
            return false;
            }
          this.cuttofErr='';
          this.outboundErr='';
          if (parseInt(this.globalThresholds.saleschannelOutbound.cutoffbased.hrs * 60) + parseInt(this.globalThresholds.saleschannelOutbound.cutoffbased.min) >= totalOrderMins - totalCutoffMins) {
            this.$alertify.alert(this.$t('sla.durationError'), this.$t('sla.durationErrMsg') + "<br/>" + `<b> ${this.$t('sla.thresholdDuration')}: ${this.globalThresholds.saleschannelOutbound.cutoffbased.hrs} ${this.$t('sla.hours')} ${this.globalThresholds.saleschannelOutbound.cutoffbased.min} ${this.$t('sla.minutes')} </b>`);
            return false;
          }
            payload = {
              tattype: "cutoff",
              saleschannel: this.searchchannel1,
              tattime: `${this.outbound.cuttofday} ${this.outbound.cuttofhrs}:${this.outbound.cuttofmin}`,
              outboundsla: `${this.outbound.orderday} ${this.outbound.orderhrs}:${this.outbound.ordermin}`
          };
          this.$parent.saveNewChannel(payload, this.outboundConfigId);
          this.outbound.fixedhrs = '';
          this.outbound.fixedmin =  '';
      }
      }
    },

    reset() {
            this.outbound.fixedhrs= "";
            this.outbound.fixedmin= "";
            this.outbound.cuttofhrs= "";
            this.outbound.cuttofmin= "";
            this.outbound.cuttofday= 1;
            this.outbound.orderhrs= "";
            this.outbound.ordermin= "";
            this.outbound.orderday= "";
            this.outboundConfigId="";
            this.fixedErr= "";
            this.cuttofErr= "";
            this.outboundErr= "";
            this.tatType= "1";
        },
  },
};
</script>
<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/views/components/SLA/saleschannel/index.vue?4474561e